import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ProjectDataStatusList } from 'src/app/entities/project-data-status.list';
import { ProjectData } from 'src/app/entities/project-data.entity';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ModelService } from 'src/app/services/model.service';
import { ConfigService } from 'src/app/app.config';
import { AlertData } from 'src/app/alert/alert-data.entity';
import { AlertComponent } from '../../alert/alert.component';
import { ProjectListService } from './project-list.service';
import { Daterangepicker } from 'ng2-daterangepicker';
import { PropagarService } from 'src/app/services/propagar.service';
import { Utils } from '../../utils.module';
import { LoginService } from 'src/app/login/login_service/login.service';
//import { UserDetailService } from '../user-detail/user-detail.service';
import { UserListService } from '../user-list/user-list.service';
import { Store } from '@ngrx/store';
import * as listProjectsActions from '../../store/listProjects/listProjects.actions';
import * as actionsPath from '../../store/path/path.actions';
//import { ListProjectsFilters, ListProjects } from '../../store/listProjects/listProjects.data';
import { goFront } from '../../store/path/path.actions';
import { ParseProjectVersion } from 'src/app/utils/parse-project-version';
import { FilterProjects } from './filters-projects';
import { AppState } from 'src/app/app.reducers';

@Component({
	selector: 'app-project-list',
	templateUrl: './project-list.component.html',
	styleUrls: ['./project-list.component.scss']
})
export class ProjectListComponent implements OnInit, AfterViewInit, OnDestroy {

	public options: any;
	public statusList: any = ProjectDataStatusList;

	// Listado con los usarios.
	public userList: any[] = [];
	public codeList: any[] = [];
	public empresaList: any[] = [];

	// TODO ########################## EVELUTIVOS 2021
	// Paginador
	//private currentFilter = -1; // Todos
	public currentPage = 0; // Actual página.
	public itemsByPage = 10; // Items por página.
	public totalPage = 0;
	public btnsPage = [];
	public showPaginete = false;

	public totalItemsByFilter = 0;// Total de items que concuerdan con el filtro en curso.

	public listNameUser: FilterProjects[];
	public listEmailUser: FilterProjects[];
	public listNameCIA: FilterProjects[];
	public listCodeCIA: FilterProjects[];

	public adminMode: boolean = false;
	public empresaMode: boolean = false;

	// ########################## EVELUTIVOS 2021

	@ViewChild('dateRangePicker') dRangePicker: Daterangepicker;
	@ViewChild('alertWindow1') alertWindow: AlertComponent;

	//@Output() GProjectLoad = new EventEmitter<string>();
	public projectList: ProjectData[];

	// init values for date range
	public startDate: Date;
	public endDate: Date;

	// value for date range from UI interaction
	public selectDate: any;					// {"start":"2019-01-31T23:00:00.000Z","end":"2020-02-29T22:59:59.999Z"}
	public selectStatus: object;			// Estado del proyecto.
	public selectProject: string = '';		// Título del proyecto.
	public selectCIA: string = '';			// Nombre de empresa.
	public selectUserId: string = '';	// Usuario por nombre.
	//public selectUserEmailId: string = '';	// Usuario por Email.
	public selectCode: string = '';			// Código de empresa.
	public currentUserId: string = '';		// Usuario con sesión.


	//
	public subscriptions: Subscription[] = [];

	public steps: Array<number> = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50];

	public GProjectLoad: any;
	public tope = 30;

	constructor(
		private store: Store<AppState>,
		private router: Router,
		private route: ActivatedRoute,
		public modelService: ModelService,
		public projectListService: ProjectListService,
		//private userProfileService: UserDetailService,
		private userListService: UserListService,
		private loginService: LoginService) {

	}

	public ngOnInit(): void {
		//console.log('ngOnInit()');
		this.loginService.isLoggedIn();

		const dataUser = this.modelService.getUser().getData();
		this.currentUserId = dataUser.id;

		// Iniciar modos según rol.
		this.adminMode = false;
		this.empresaMode = false;

		// Cambia de página, lanza una nueva select con el filtro actual.
		this.store.subscribe(store => {
			if (this.currentPage !== store.listProjects.currentPage) {
				this.currentPage = store.listProjects.currentPage;
				this.doFilter();
			}
		});

		// Se cargan los usuarios dependiendo del Rol.
		if (dataUser.rol === 1 || dataUser.rol === 11) {
			this.adminMode = true;
			// >>> ADMINS
			this.subscriptions.push(this.projectListService.getUsersActives().subscribe((rs) => {
				// Iniciar lisa de usuarios.
				this.userList = rs;
				// Ordenar user name y email.
				this.orderUserNameEmail();
				// Ordenar las empresas.
				this.orderCIANameCode();
			}));
		}
		else if (dataUser.rol === 10) {
			this.empresaMode = true;
			this.selectCode = dataUser.numCliRivisa;
			// >>> EMPRESA
			this.subscriptions.push(this.projectListService.getUsersCIA(dataUser.numCliRivisa).subscribe((rs) => {
				// Iniciar lista de usuarios.
				this.userList = rs;
				// Ordenar user name y email.
				this.orderUserNameEmail();
			}));
		}
		else {
			// Para usuarios normales, solo puede ver sus proyectos.
			this.userList.push(dataUser);
		}

		//if (data.rol == 1 || data.rol == 11) {
		// Perdir los usuarios, no debe devolver los usuarios que estén en espera ni eliminados.
		//this.subscriptions.push(this.projectListService.getUsersActives().subscribe((rs) => {
		// Iniciar lisa de usuarios.		//this.userList = rs;
		//if (this.empresaMode) {		// Preparar listados para empresa.		// Obtener los usarios que le corresponden.
		// Ordenar emails.		// NO UTILIZA EMPRESA ES SIEMPRE LA MISMA.		//}				else {
		// Preparar listados para admin.		// Ordenar los emails.		// Ordenar las empresas.		// Ordenar los códigos.		//}
		/*	// Iniciar lista de código de empresas.	this.codeList = [];	// Bucle para eliminar repeticiones.
						for (let i = 0; i < rs.length; i++) {// Si es el primer elemento no se discute.	if (this.codeList.length === 0) {
								this.empresaList.push(rs[i]);this.codeList.push(rs[i]);	}else {
								// Evitar las repeticiones en código de empresa.
								let _code = this.codeList.find(item => item.numCliRivisa === rs[i].numCliRivisa);
								if (_code === undefined) {this.codeList.push(rs[i]);}
								// Evitar las repeticiones en nombre de empresa.
								let _empresa = this.empresaList.find(item => item.empresa === rs[i].empresa);
								if (_empresa === undefined) {	this.empresaList.push(rs[i]);	}	}		}
						this.empresaList = this.empresaList.sort((a, b) => a.empresa.toLowerCase() - b.empresa.toLowerCase());
						this.codeList = this.codeList.sort((a, b) => a.numCliRivisa - b.numCliRivisa);	}));} */

		// iniciar rango de fechas.
		let start = new Date();
		let end = new Date();
		// Dar un margen entre inicio y final.
		start.setDate(start.getDate() - this.tope); // Último mes.

		this.doFilter(true);

		this.selectDate = {
			start: start.toISOString(),
			end: end.toISOString()
		}

		var i = document.getElementById('webContents');
		if (i) i.setAttribute('style', "");

		const self = this;
		if (!this.modelService.getLanguage().isLoaded) {
			this.subscriptions.push(
				this.modelService.getLanguage().onLanguageLoaded
					.subscribe(() => this.fillOptions())
			);
		} else {
			this.fillOptions();
		}

		/** interfaz de usuario segun admin/regular user */
		this.subscriptions.push(this.route.data.subscribe((data: { showMargin: boolean }) => { }));

		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				// ToDO: better route handling
				if (event.url === '/project-list' || event.url === '/estimation-list') {
					this.fillOptions();
				}
			}
		});
		//	this.GProjectLoad = new CustomEvent('GProjectLoad', { detail: {id: 'ok'}});
	}

	// Filtra el listado de ususarios dependiendo del rol.
	// Siempre ordenar combo nombre alfabeticamente por Apellidos, Nombre.
	// Siempre ordenar combo email alfabeticamente por Email.
	private orderUserNameEmail(cia: string = '') {
		this.listNameUser = [];
		this.listEmailUser = [];
		for (let i = 0; i < this.userList.length; i++) {
			let item = this.userList[i];
			if (!(cia !== '' && cia !== item.numCliRivisa)) {
				this.listNameUser.push({ id: item._id, code: item.numCliRivisa, title: item.apellidos + ', ' + item.nombre });
				this.listEmailUser.push({ id: item._id, code: item.numCliRivisa, title: item.email });
			}
		}
		// Ordenar.
		if (this.listNameUser.length > 1) {
			this.listNameUser = this.listNameUser.sort((a, b) => a.title.localeCompare(b.title));
			this.listEmailUser = this.listEmailUser.sort((a, b) => a.title.localeCompare(b.title));
		}
	}

	// Filtra el listado de usuario dependiendo del rol.
	// Siempre ordenar combo nombre empresanombre alfabeticamente por empresa.
	// Siempre ordenar combo codigo ascendente.
	private orderCIANameCode() {
		this.listNameCIA = [];
		this.listCodeCIA = [];
		for (let i = 0; i < this.userList.length; i++) {
			let item = this.userList[i];

			// Evitar que se repita una empresa con el mismo nombre y código.
			let _aux = this.listNameCIA.find(cia => cia.code === item.numCliRivisa && cia.title === item.empresa);
			if (_aux === undefined) {
				this.listNameCIA.push({ id: item._id, code: item.numCliRivisa, title: item.empresa });
			}

			// Evitar que se repita una empresa con el mismo código.
			_aux = this.listCodeCIA.find(cia => cia.code === item.numCliRivisa);
			if (_aux === undefined) {
				this.listCodeCIA.push({ id: item._id, code: item.numCliRivisa, title: item.numCliRivisa });
			}
		}
		// Ordenar.
		this.listNameCIA = this.listNameCIA.sort((a, b) => a.title.localeCompare(b.title));
		this.listCodeCIA = this.listCodeCIA.sort((a, b) => a.title.localeCompare(b.title));
	}

	public ngAfterViewInit() {
		//console.log('ngAfterViewInit()');
		this.selectDate = this.dRangePicker['datePicker'];
		this.selectStatus = ProjectDataStatusList[-1];
	}

	public ngOnDestroy(): void { //console.log('ngOnDestroy()');
		this.subscriptions.forEach((subs: Subscription) => { subs.unsubscribe(); }, this);
	}

	private fillOptions(): void {
		/**Comentado para no cargar los filtros de fechas guardados en localStorage */
		//const projectListDateRange = JSON.parse(localStorage.getItem('projectListDateRange'));
		/**Eliminamos 'projectListDateRange' para empezar sin filtro de fechas y mostras 6 meses atras */
		//localStorage.removeItem('projectListDateRange');
		this.options = {
			locale: {
				format: ConfigService.DATE_FORMAT,
				separator: ' - ',
				applyLabel: this.modelService.getString('project_list_calendar_apply'),
				cancelLabel: this.modelService.getString('project_list_calendar_cancel'),
				//fromLabel: this.modelService.getString('project_l ist_calendar_from'),
				//toLabel: this.modelService.getString('project_list_ calendar_to'),
				//customRangeLabel: this.modelService.getString('project_list _calendar_custom'),
				weekLabel: 'W',
				daysOfWeek: [
					this.modelService.getString('project_list_calendar_day_07'),
					this.modelService.getString('project_list_calendar_day_01'),
					this.modelService.getString('project_list_calendar_day_02'),
					this.modelService.getString('project_list_calendar_day_03'),
					this.modelService.getString('project_list_calendar_day_04'),
					this.modelService.getString('project_list_calendar_day_05'),
					this.modelService.getString('project_list_calendar_day_06'),
				],
				monthNames: [
					this.modelService.getString('project_list_calendar_month_01'),
					this.modelService.getString('project_list_calendar_month_02'),
					this.modelService.getString('project_list_calendar_month_03'),
					this.modelService.getString('project_list_calendar_month_04'),
					this.modelService.getString('project_list_calendar_month_05'),
					this.modelService.getString('project_list_calendar_month_06'),
					this.modelService.getString('project_list_calendar_month_07'),
					this.modelService.getString('project_list_calendar_month_08'),
					this.modelService.getString('project_list_calendar_month_09'),
					this.modelService.getString('project_list_calendar_month_10'),
					this.modelService.getString('project_list_calendar_month_11'),
					this.modelService.getString('project_list_calendar_month_12')
				],
				firstDay: 1
			},
			startDate: new Date(),
			endDate: new Date().getTime(),
			alwaysShowCalendars: false,
		};
		/**Comentado para no aplicar filtro fechas de localStorage cuando se sale y se entra del listado de proyectos */
		//if (projectListDateRange) {
		//	this.options.startDate = new Date(projectListDateRange.start);
		//	this.options.endDate = new Date(projectListDateRange.end);
		//	this.startDate = new Date(projectListDateRange.start);
		//	this.endDate = new Date(projectListDateRange.end);
		//} else {
		/** fechas por defecto de los filtros */
		const currentDate: Date = this.options.startDate;
		currentDate.setMonth(currentDate.getMonth() - 1);
		this.endDate = new Date();
		this.startDate = new Date();
		this.startDate.setMonth(this.startDate.getMonth() - 1);
		//}

		this.doFilter();
	}

	/** seleccion de fechas leyendo del picker. ToDo: Why this? */
	public calendarApplied(date: any): void {
		this.selectDate = {
			start: date.picker.startDate,
			end: date.picker.endDate
		};
		//localStorage.setItem('projectListDateRange', JSON.stringify(this.selectedDate));
	}

	/** seleccion de fechas leyendo del evento de selección */
	public onSelectDate(date: any): void {
		// console.log('>>>>>>> DATE CHANGED');
		this.selectDate = date;
		this.doFilter(true);
		//this.analyticsService.setUserAction('onProjectFilterByDate', date);
		//localStorage.setItem('projectListDateRange', JSON.stringify(this.selectedDate));
	}

	/** seleccion de estado del proyecto */
	public onSelectStatus(target: any): void {
		const statusStr = target.currentTarget.value;
		//console.log('>>>>>>>>>>>>>>> ESTADO::' + statusStr);
		this.selectStatus = ProjectDataStatusList.find((item) => {
			const currentItemStr = this.modelService.getString(item.label);
			return statusStr === currentItemStr;
		});
		this.doFilter(true);
	}

	// ############################################### NUEVOS EVOLUTIVOS 2021
	public onSelectUser(target: any): void {
		this.doFilter(true);
	}

	// Cambiar nombre usuario. Admins y Empresa.
	// Debe modificarse el email y en caso de admins la empresa(n) y su cócigo.
	public onSelectUserNameEmail(target: any) {
		//if (this.adminMode) {
		// TODO ¿Cambiar empresa?
		//if (this.selectUserId && this.selectUserId .length > 0) {
		//let user = this.listNameUser.find(item => item.id === this.selectUserId);
		//let cia = this.listNameUser.find(item => item.id === this.selectUserId && item.code === this.selectCIA);
		//if (!cia) {
		//this.selectCIA = user.code;
		//return;
		//}
		//}
		//}
		this.doFilter(true);
	}

	public onSelectCIANameCode(target: any) {
		if (this.adminMode) {
			// En caso de selecciona ver todas las empresas.
			if (this.selectCIA && this.selectCIA.length > 0) {
				// Ver todas las empresa.
				// Recuperar los usuraios.
				this.selectUserId = '';
				this.orderUserNameEmail(this.selectCIA);
			}
			else {
				this.selectUserId = '';
				this.orderUserNameEmail();
			}
			this.doFilter(true);
		}
	}
	// ############################################### NUEVOS EVOLUTIVOS 2021

	private numOk(value: number): number { return parseFloat(value.toFixed(3)); }

	/** buscar por nombre de proyecto */
	// Formato "UserID,nombreProyecto,FechaInicio,FechaFinal,estado,numCliRivisa,currentPage,itemsByPage"
	// userid o email(str)),nombreProyecto(str),DateStart(num),DateEnd(num),estado(num), nombreEmpresa o codigo(str),actual página(num), items por página(num)
	public doFilter(reinit: boolean = false): void {
		// Si reinit = true se resetea el págiador.
		if (reinit) {
			this.currentPage = 0;
			this.store.dispatch(listProjectsActions.setCurrentPage({ page: 0 }));
		}

		let filter = "";
		// ########## userID
		// ADMIN: obtenido de los listados de nombre usuario o email.
		// EMPRESA: obtenido de los listados de nombre usuario o email.
		// USER: no es seleccionable se toma del usuario loginado.
		if (this.adminMode || this.empresaMode) {
			// Tener en cuenta que se selecciono un usuario.
			if (this.selectUserId && this.selectUserId.length > 0) {
				filter += this.selectUserId;
			}
		}
		else {
			// Es usuario normal, solo puede ver sus proyectos.
			filter += this.currentUserId;
		}
		filter += ",";

		// ########## nombreProyecto
		// Todos los ROLES: solo tener en cuenta que hay texto a buscar.
		if (this.selectProject && this.selectProject.length > 0) filter += this.selectProject;
		filter += ',';

		// ########## FechaInicio y FechaFinal (incondicional, siempre se cumple)
		// Todos los ROLES: formatear el formato adecuado para el filtro en mongoDB.
		if (this.selectDate) {
			let dtA = new Date(this.selectDate.start);
			let dtB = new Date(this.selectDate.end);
			// console.log(dtA.getTime().toString() + ',' + dtB.getTime().toString());
			filter += dtA.getTime().toString() + ',' + dtB.getTime().toString() + ',';
		}
		else {
			let dtA = new Date();
			let dtB = new Date();
			dtA.setDate(dtA.getDate() - this.tope);
			filter += dtA.getTime().toString() + ',' + dtB.getTime().toString() + ',';
		}

		// ########## estado
		// Todos los ROLES: si hay un rol seleccionado incluirlo.
		if (this.selectStatus && this.selectStatus['value'] > -1) filter += this.selectStatus['value'].toString();
		filter += ',';

		// ########## numCliRivisa
		// SOLO ADMINS: el código se obtiene de los listados Empresa o Código.
		if (this.empresaMode) {
			filter += this.modelService.getUser().getData().numCliRivisa;
		}
		else if (this.selectCIA && this.selectCIA.length > 0) {
			filter += this.selectCIA;
		}
		filter += ',';

		// ########## Actual página y páginas a mostrar
		filter += this.currentPage + ',' + this.itemsByPage;

		// tener en cuenta que hay usrNameid y userEmailid #### FILTRO userId ####
		// Si es admin y tiene seleccionado un usuario se filtra por usuario.
		//if (this.adminMode && this.selectUserId && this.selectUserId.length > 0) { filter += this.selectUserId;	}
		//else if (!this.adminMode && !this.empresaMode) { // Si no es admin se filtra por el usuario actual
		//	filter += this.currentUserId;	}	filter += ",";

		// #### FILTRO nombre proyecto ####
		//if (this.selectProject && this.selectProject.length > 0) filter += this.selectProject;
		// #### FILTRO Fecha inicio y facha final ####
		//filter += ',';
		/*if (this.selectDate) {
			let dtA = new Date(this.selectDate.start);
			let dtB = new Date(this.selectDate.end);
			filter += dtA.getTime().toString() + ',' + dtB.getTime().toString() + ',';
		}
		else {
			let dtA = new Date();
			let dtB = new Date();
			dtA.setDate(dtA.getDate() - this.tope);
			filter += dtA.getTime().toString() + ',' + dtB.getTime().toString() + ',';
		}*/
		// #### FILTRO estado ####
		//if (this.selectStatus && this.selectStatus['value'] > 0) filter += this.selectStatus['value'].toString();
		// #### FILTRO nombre user ¿? ####
		// #### FILTRO nombre Empresa ####
		// #### FILTRO código ####

		this.subscriptions.push(this.projectListService.getFilterProjects(filter)
			//this.subscriptions.push(this.projectListService.getFilterProjects(JSON.stringify(f))
			.subscribe((result: any) => {
				//console.log(rs);
				this.totalItemsByFilter = result.count;
				let rs = result.projectList;
				rs.forEach((p) => {
					if (p.renderer === Utils.SCHEME2) {
						let X1 = 0;
						let X2 = 0;
						let Y1 = 0;
						let Y2 = 0;
						let path = [];
						let auxLat = 0;
						let auxLng = 0;
						p.perimetro.forEach((pr) => {
							for (let i = 0; i < pr.coordenadas.length; i++) {
								if (i == 0) path.push('M'); else path.push('L');

								auxLng = this.numOk(pr.coordenadas[i].lng * 100);
								auxLat = (this.numOk(pr.coordenadas[i].lat * 100)) * -1;

								path.push(auxLng);
								path.push(auxLat);

								if (i == 0 && X1 == 0) { X1 = auxLng; X2 = auxLng; }
								else if (auxLng < X1) X1 = auxLng;
								else if (auxLng > X2) X2 = auxLng;

								if (i == 0 && Y1 == 0) { Y1 = auxLat; Y2 = auxLat; }
								else if (auxLat < Y1) Y1 = auxLat;
								else if (auxLat > Y2) Y2 = auxLat;

								//console.log(`lng:${auxLng} | lat:${auxLat} || X1:${X1}; X2:${X2}; Y1:${Y1}; Y2:${Y2}`);
							}
						});

						// Quitar negativos.
						if (X1 < 0) {
							const suma = this.numOk(X1 * -1);
							X1 = 0;
							X2 = this.numOk(X2 + suma);
							for (let i = 1; i < path.length; i += 3) path[i] = this.numOk(path[i] + suma);
						}

						if (Y1 < 0) {
							const suma = this.numOk(Y1 * -1);
							Y1 = 0;
							Y2 = this.numOk(Y2 + suma);
							for (let i = 2; i < path.length; i += 3) path[i] = this.numOk(path[i] + suma);
						}

						// Alinear a cero.
						if (X1 > 0) {
							const resta = X1;
							X1 = 0;
							X2 = this.numOk(X2 - resta);
							for (let i = 1; i < path.length; i += 3) path[i] = this.numOk(path[i] - resta);
						}

						if (Y1 > 0) {
							const resta = Y1;
							Y1 = 0;
							Y2 = this.numOk(Y2 - resta);
							for (let i = 2; i < path.length; i += 3) path[i] = this.numOk(path[i] - resta);
						}

						p.mini = {
							'viewBox': `${X1},${Y1},${X2},${Y2}`,
							'path': path.join(' ')
						};
						//console.log(JSON.stringify(p.mini));
					}
				});
				this.projectList = rs;
				this.showPaginete = this.calculatePages(this.totalItemsByFilter);
			}));
	}

	public getProjectImageSatelite(project: ProjectData, img: string): string {
		if (project.renderer !== Utils.SATELITE) return "/assets/img/sateliteMini.jpg";
		return this.getProjectImageFromGoogle(project, img);
	}

	public getProjectImageEsquema(project: ProjectData): string {
		if (project.renderer === Utils.SATELITE) return "/assets/img/esquemaMini.jpg";
	}

	public saveMiniSatelite(project: ProjectData, index: string) {
		return;
	}

	/** recupera la imagen del proyecto via google maps */
	private getProjectImageFromGoogle(project: ProjectData, img: string): string {
		// Crear la URL.
		let url = 'http://maps.googleapis.com/maps/api/staticmap?maptype=hybrid&size=192x120&key=' + ConfigService.GOOGLE_API_KEY;
		// Almacena si tiene perímetros ??????
		let hasPerimeter: boolean = false;
		// Recorre todos los perímetros para obtener sus puntos.
		project.perimetro.forEach((perimetro) => {
			//url += '&path=';
			let points = [];
			perimetro.coordenadas.forEach((coord) => {
				let lat = 41.3047326;
				let lng = 2.0859696;
				if (!coord.dots || coord.dots.length == 0) {
					if (coord.lat) {
						lat = coord.lat;
						lng = coord.lng;
					}
				} else {
					lat = coord.dots[0].lat;
					lng = coord.dots[0].lng;
				}
				points.push(lat + ',' + lng);
				hasPerimeter = true;
			});
			if (hasPerimeter) url += '&path=' + points.join('|');
		}, this);
		return url;
	}

	// Petición al servidor de la miniatura del proyecto Esquema.
	public getProjectImageFromBackend(project: ProjectData): string {
		return ConfigService.REST_SERVER + '/api/image/project/192/120/' + project._id;
	}

	// ### Viene del listado y vuelca el proyecto, en relidad se debería llamar al backend y pedir el proyecto.
	public editProject(project: ProjectData): void {
		const _his = this.userListService.historyProjects(project._id, project.nombre, project.renderer, this.modelService.getUser().getData())
			.subscribe(() => { _his.unsubscribe(); });
		// Almacenar proyecto en el localStorage.
		localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(project));

		// Versionador de proyectos.
		let newVersion = new ParseProjectVersion();
		project = newVersion.parse(project);
		localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(project));

		// Avisar que no viene del 3D.
		this.store.dispatch(actionsPath.iDontComingFrom3D());

		if (project.renderer === Utils.SATELITE) {
			this.router.navigate(['/satelite']);
			setTimeout(() => { PropagarService.get('GProjectLoadSatelite').emit('All right!'); }, 200);
		}
		else {
			// console.log(Utils.SCHEME2);
			this.router.navigate(['/scheme']);
			//setTimeout(() => { Propagar Service.get('G ProjectLoadScheme').emit('All right!'); }, 200);
			setTimeout(() => { this.modelService.GProjectLoadScheme.emit('All right!'); }, 200);
		}
	}

	// TODO SE DEBERÍA CREAR UN COMPONENTE APARTE PARA NO MEZCLARLO.
	// ### Ver presupuesto.
	public viewQuote(project: ProjectData): void {
		const por = localStorage.getItem(Utils.CURRENT_PROJECT);
		let currentId = '';
		if (por !== null) {
			const dt = JSON.parse(por);
			currentId = dt._id || '';
		}

		// Avisar que no viene del 3D.
		this.store.dispatch(actionsPath.iDontComingFrom3D());

		localStorage.setItem(Utils.PREVIOUS_CURRENT_PROJECT, currentId);
		localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(project));
		// Navegar al presupuesto.
		this.store.dispatch(goFront({ path: '/estimation-list' }));
		this.router.navigate(['/project-detail']);
	}

	// ### BORRAR PROYECTO.
	// ¿Se pueden borrar proyectos en revisíon?
	public deleteProject(project: ProjectData): void {
		// SOLO se pueden borrar los proyectos en estado Borrador.
		if (project.estado > 0) return;
		// SOLO el propietario puede borrar el archivo.
		if (!this.adminMode && project.userId !== this.modelService.getUser().getData().id) return;

		// Avisar si desea eliminar el proyecto, evitar equivocación.
		const data: AlertData = new AlertData();
		data.title = this.modelService.getString('project_list_delete_title');
		data.messages = this.modelService.getString('project_list_delete_body').split('#');
		data.type = 'modal';
		this.alertWindow.show(data);

		const subWindow = this.modelService.alertResultSignal.subscribe((shouldRemove: boolean) => {
			subWindow.unsubscribe();
			this.alertWindow.close();
			if (shouldRemove) {
				const subs = this.projectListService.deleteProject(project._id).subscribe(() => {
					subs.unsubscribe();
					// Comprobar si el actual proyecto el que ha sido borrado.
					const pd: ProjectData = JSON.parse(localStorage.getItem(Utils.CURRENT_PROJECT));
					if (pd && pd._id === project._id) {
						localStorage.removeItem(Utils.CURRENT_PROJECT);
					}
					// Reducir el proyecto eliminado.
					this.totalItemsByFilter--;

					// Debe exsistir paginación.
					if (this.totalItemsByFilter >= this.itemsByPage) {
						// Si está en la primer página ignorar.
						if (this.currentPage > 0) {
							// Si la eliminación del proyecto a generado una página vacia, retrocer una página.
							if (this.totalItemsByFilter - (this.currentPage * this.itemsByPage) <= 0) {
								// Llama a doFilter();
								this.store.dispatch(listProjectsActions.setCurrentPage({ page: this.currentPage - 1 }));
								return;
							}
						}
					}
					this.doFilter();
				});
			}
		});
	}

	public mcChange(project: ProjectData): void {
		const cp = localStorage.getItem(Utils.CURRENT_PROJECT);
		// Hay proyecto abierto
		if (cp !== null) {
			const dt = JSON.parse(cp);
			// Si proyecto ya iniciado y es el mismo proyecto -> actualizar el localStorage.
			if (dt._id && dt._id !== '' && dt._id === project._id) {
				localStorage.setItem(Utils.CURRENT_PROJECT, JSON.stringify(project));
			}
		}
		this.projectListService.saveMCProject(project);
	}

	//#region ______________________________________________________ UI
	// Devuelve el nomre y apellidos del usuario.
	public getNamesUser(userId: string): string {
		if (this.adminMode || this.empresaMode) {
			let user = this.userList.find(item => item._id === userId);
			return (user) ? `${user.nombre} ${user.apellidos}` : ' ';
		}
		else {
			return `${this.modelService.getUser().getData().nombre} ${this.modelService.getUser().getData().apellidos}`;
		}
	}

	// Devuelve el nombre de la empresa.
	public getCIA(userId: string): string {
		if (this.adminMode || this.empresaMode) {
			let user = this.userList.find(item => item._id === userId);
			return (user) ? user.empresa : ' ';
		}
		else {
			return this.modelService.getUser().getData().empresa;
		}
	}

	// Controla la visualización del botón eliminar proyecto del submenú.
	public buttonDeleteProject(project: ProjectData): boolean {
		// Solo se eliminan los poryectos en estado borrador.
		if (project.estado > 0) return true;
		//if (this.adminMode || this.empresaMode) return false;
		// Si se entra con rol empresa, solo puede eliminar sus proyectos.
		//console.log(`${this.modelService.getUser().getData().id} !== ${project.userId} = ${this.modelService.getUser().getData().id !== project.userId}`);
		return (this.modelService.getUser().getData().id !== project.userId);
	}
	//#endregion

	//#region ______________________________________________________ PAGINACIÓN
	private calculatePages(count: number): boolean {
		// Mapeo de las páginas.
		let _aux = [];

		// Si no hay registros salir con falso.
		if (count === 0) return false;

		//	setTimeout(() => {
		// Obtener la cantidad de páginas.
		this.totalPage = Math.floor(count / this.itemsByPage);
		if ((count % this.itemsByPage) > 0) this.totalPage++;

		// En caso de superar siete páginas.
		let init = 0; // Principio.
		let end = this.totalPage;
		if (this.totalPage > 5) {
			if (this.currentPage > 2) {
				if (this.currentPage > (this.totalPage - 3)) {
					init = this.totalPage - 5; // Final.
				}
				else {
					init = this.currentPage - 2; // Centrado.
				}
			}
			end = init + 5;
		}

		for (let i = 0; i < end; i++) {
			//this.btnsPage.push({ active: false, page: i, text: (i + 1).toString() });
			_aux.push({ active: false, page: i, text: (i + 1).toString() });
		}
		this.btnsPage = _aux;

		//}, 1);
		return this.btnsPage.length > 1;
	}

	// Ir a la página indicada.
	public paginate(page: number) {
		if (this.currentPage !== page && page > -1 && page < this.totalPage) {
			this.store.dispatch(listProjectsActions.setCurrentPage({ page: page }));
		}
	}

	// Retroceder a la página anterior.
	public nextPage() {
		if (this.currentPage < (this.totalPage - 1)) {
			this.store.dispatch(listProjectsActions.setCurrentPage({ page: this.currentPage + 1 }));
		}
	}

	// Pasar a la siguiente página.
	public previousPage() {
		if (this.currentPage > 0) {
			this.store.dispatch(listProjectsActions.setCurrentPage({ page: this.currentPage - 1 }));
		}
	}

	// Situarse en la última página.
	public lastPage() {
		if (this.currentPage < (this.totalPage - 1)) {
			this.store.dispatch(listProjectsActions.setCurrentPage({ page: this.totalPage - 1 }));
		}
	}

	// Situarse en la primera página.
	public firstPage() {
		if (this.currentPage > 0) {
			this.store.dispatch(listProjectsActions.setCurrentPage({ page: 0 }));
		}
	}
	//#endregion
}

//public addNewProject(): void {localStorage.setItem(Utils. CURRENT_PROJECT, JSON.stringify(new ProjectData()));
//this.router.navigate([' /hold']);	this.router.navigate([' /satelite']);}
	//public ngDoCheck() { console.log('ngDoCheck()'); }
	//public ngOnChanges() { console.log('ngOnChanges()'); }
	//public ngAfterContentChecked() { console.log('ngAfterContentChecked()'); }
	//public ngAfterViewChecked() {	console.log('ngAfterViewChecked()'); }
